<template>
  <div class="article-role-selector">
    <dd class="one-column">
      <label class="select-input">
        <span>Admin - ผู้สร้างและประกาศข่าวทุกโครงการ</span>
        <input
          type="radio"
          :value="adminRole"
          name="articleRole"
          v-model="articleRole"
          @click="handleChange(adminRole)"
        />
        <span class="checkmark radio"></span>
      </label>
      <label class="select-input gray" v-if="canSelectArticleRoleAdminOnly">
        <span>Editor - ผู้สร้างและอนุมัติประกาศข่าวเฉพาะโครงการที่ดูแล</span>
        <input type="radio" value="2" v-model="articleRole" disabled/>
        <span class="checkmark radio"></span>
      </label>
      <label class="select-input" v-else>
        <span>Editor - ผู้สร้างและอนุมัติประกาศข่าวเฉพาะโครงการที่ดูแล</span>
        <input
          type="radio"
          :value="editorRole"
          name="articleRole"
          v-model="articleRole"
          @click="handleChange(editorRole)"
        />
        <span class="checkmark radio"></span>
      </label>
      <label class="select-input gray" v-if="canSelectArticleRoleAdminOnly">
        <span>Creator - ผู้สร้างประกาศข่าวเฉพาะโครงการที่ดูแล</span>
        <input type="radio" value="3" v-model="articleRole" disabled/>
        <span class="checkmark radio"></span>
      </label>
      <label class="select-input" v-else>
        <span>Creator - ผู้สร้างประกาศข่าวเฉพาะโครงการที่ดูแล</span>
        <input
          type="radio"
          :value="creatorRole"
          name="articleRole"
          v-model="articleRole"
          @click="handleChange(creatorRole)"
        />
        <span class="checkmark radio"></span>
      </label>
    </dd>
  </div>
</template>

<script>
import { Input, Select } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

export default {
  components: {
    "el-input": Input,
    "el-select": Select
  },
  props: ["value", "isCreatingStaff", "roles", "staffRoleId"],
  computed: {
    articleRole: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    canSelectArticleRoleAdminOnly() {
      if (!this.roles || !this.staffRoleId) {
        return false;
      }

      const roleName = this.roles.find(
        role => role.role_id === this.staffRoleId
      ).role_name;

      return ["Admin"].includes(roleName);
    },
    adminRole() {
      return 1;
    },
    editorRole() {
      return 2;
    },
    creatorRole() {
      return 3;
    }
  },
  watch: {
    canSelectArticleRoleAdminOnly() {
      if (this.isCreatingStaff) {
        this.handleChange(this.adminRole);
      }
    }
  },
  methods: {
    handleChange(value) {
      this.$emit("input", value);
    }
  }
}
</script>

<style lang="scss" scoped>
.article-role-selector {
  dd {
    &.one-column {
      display: table-caption;
      column-count: 1;
      margin-left: 76px;

      .select-input > span:first-child {
        width: 30em;
        display: inline-block;
      }
    }
  }
}

.gray {
  color: #CDCDCD;
}

</style>


// WEBPACK FOOTER //
// src/components/admin/view/staff/components/ArticleRoleSelector.vue